/*! *********************************************************************
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */

import gql from 'graphql-tag';

const QUERY_TRANSACTIONS = gql`
  query Transactions(
    $sortDir: SortDir = desc
    $page: Int
    $limit: Int = 20
    $filters: TransactionsFilters
  ) {
    transactions(
      sortDir: $sortDir
      page: $page
      limit: $limit
      filters: $filters
    ) {
      total
      hasMore
      items {
        id
        type
        userId
        productId
        productName
        voided
        currentBalance
        createdAt
        updatedAt
      }
    }
  }
`;

const QUERY_USER_TRANSACTIONS = gql`
  query Transactions($userId: String!) {
    userAccount(identityId: $userId) {
      points
      # balance
      licenses {
        unlimited {
          status
          expirationDate
        }
        standard {
          status
          expirationDate
        }
        premium {
          status
          expirationDate
        }
      }
      assetIds
    }
  }
`;

export default QUERY_TRANSACTIONS;
export { QUERY_TRANSACTIONS, QUERY_USER_TRANSACTIONS };
